const EMOJI_MAP = [
    {
        description: 'shrug',
        codes: ['shrug'],
        snippets: ['/shrug'],
        default: 'shrug',
        emoji: '¯\\_(ツ)_/¯',
    },
    {
        description: 'Slightly Smiling Face',
        codes: ['smile'],
        snippets: [':)'],
        default: ':)',
        fileName: 'yard-smiley-3',
        emoji: '\u{1F642}',
    },
    {
        description: 'Smirking Face',
        codes: ['smirk'],
        snippets: [],
        default: 'smirk',
        fileName: 'yard-smiley-4',
        emoji: '\u{1F60F}',
    },
    {
        description: 'Thumb Up',
        codes: ['like'],
        snippets: [],
        default: 'like',
        fileName: 'yard-smiley-like',
        emoji: '\u{1F44D}',
    },
    {
        description: 'Face With Stuck-Out Tongue',
        codes: ['stuck_out_tongue'],
        snippets: [':P'],
        default: ':P',
        fileName: 'yard-smiley-1',
        emoji: '\u{1F61B}',
    },
    {
        description: 'Grinning Face With Smiling Eyes',
        codes: ['grin'],
        snippets: [],
        default: 'grin',
        fileName: 'yard-smiley-2',
        emoji: '\u{1F604}',
    },
    {
        description: 'Sleepy Face',
        codes: ['sleepy'],
        snippets: [],
        default: 'sleepy',
        fileName: 'yard-smiley-5',
        emoji: '\u{1F62A}',
    },
    {
        description: 'Face With Tears of Joy',
        codes: ['joy'],
        snippets: [':D'],
        default: ':D',
        fileName: 'yard-smiley-6',
        emoji: '\u{1F602}',
    },
    {
        description: 'Neutral Face',
        codes: ['neutral_face'],
        snippets: [':|'],
        default: ':|',
        fileName: 'yard-smiley-7',
        emoji: '\u{1F610}',
    },
    {
        description: 'Grinning Face',
        codes: ['grinning'],
        snippets: [],
        default: 'grinning',
        fileName: 'yard-smiley-8',
        emoji: '\u{1F600}',
    },
    {
        description: 'Face With Open Mouth',
        codes: ['open_mouth'],
        snippets: [],
        default: 'open_mouth',
        fileName: 'yard-smiley-9',
        emoji: '\u{1F62E}',
    },
    {
        description: 'Smiling Face With Heart-Eyes',
        codes: ['heart_eyes'],
        snippets: [],
        default: 'heart_eyes',
        fileName: 'yard-smiley-10',
        emoji: '\u{1F60D}',
    },
    {
        description: 'Angry Face',
        codes: ['angry'],
        snippets: [],
        default: 'angry',
        fileName: 'yard-smiley-11',
        emoji: '\u{1F620}',
    },
    {
        description: 'Confounded Face',
        codes: ['confounded'],
        snippets: [],
        default: 'confounded',
        fileName: 'yard-smiley-12',
        emoji: '\u{1F616}',
    },
    {
        description: 'Smiling Face With Open Mouth & Cold Sweat',
        codes: ['sweat_smile'],
        snippets: [],
        default: 'sweat_smile',
        fileName: 'yard-smiley-13',
        emoji: '\u{1F605}',
    },
    {
        description: 'Face Blowing a Kiss',
        codes: ['kissing_heart'],
        snippets: [],
        default: 'kissing_heart',
        fileName: 'yard-smiley-14',
        emoji: '\u{1F618}',
    },
    {
        description: 'Winking Face',
        codes: ['wink'],
        snippets: [';)'],
        default: ';)',
        fileName: 'yard-smiley-15',
        emoji: '\u{1F609}',
    },
    {
        description: 'Loudly Crying Face',
        codes: ['sob'],
        snippets: [],
        default: 'sob',
        fileName: 'yard-smiley-16',
        emoji: '\u{1F62D}',
    },
    {
        description: 'Worried Face',
        codes: ['worried'],
        snippets: [],
        default: 'worried',
        fileName: 'yard-smiley-18',
        emoji: '\u{1F61F}',
    },
    {
        description: 'Smiling Face With Sunglasses',
        codes: ['sunglasses', 'cool'],
        snippets: [],
        default: 'sunglasses',
        fileName: 'yard-smiley-19',
        emoji: '\u{1F60E}',
    },
    {
        description: 'Persevering Face',
        codes: ['persevere'],
        snippets: [],
        default: 'persevere',
        fileName: 'yard-smiley-20',
        emoji: '\u{1F623}',
    },
    {
        description: 'Crying Face',
        codes: ['cry'],
        snippets: [],
        default: 'cry',
        fileName: 'yard-smiley-21',
        emoji: '\u{1F622}',
    },
    {
        description: 'Disappointed Face',
        codes: ['disappointed', 'anguished'],
        snippets: [':('],
        default: ':(',
        fileName: 'yard-smiley-22',
        emoji: '\u{1F61E}',
    },
    {
        description: 'Face Without Mouth',
        codes: ['no_mouth'],
        snippets: [],
        default: 'no_mouth',
        fileName: 'yard-smiley-23',
        emoji: '\u{1F636}',
    },
    {
        description: 'Expressionless Face',
        codes: ['expressionless'],
        snippets: [],
        default: 'expressionless',
        fileName: 'yard-smiley-24',
        emoji: '\u{1F611}',
    },
    {
        description: 'Face With Medical Mask',
        codes: ['mask'],
        snippets: [],
        default: 'mask',
        fileName: 'yard-smiley-25',
        emoji: '\u{1F637}',
    },
    {
        description: 'Face With Open Mouth',
        codes: ['open_mouth'],
        snippets: [],
        default: 'open_mouth',
        fileName: 'yard-smiley-26',
        emoji: '\u{1F62E}',
    },
    {
        description: 'Kissing Face With Smiling Eyes',
        codes: ['kissing_smiling_eyes'],
        snippets: [':*'],
        default: ':*',
        fileName: 'yard-smiley-27',
        emoji: '\u{1F619}',
    },
    {
        description: 'Rolling on the Floor Laughing',
        codes: ['rotfl'],
        snippets: ['xD'],
        default: 'xD',
        fileName: 'yard-smiley-29',
        emoji: '\u{1F923}',
    },
    {
        description: 'Smiling Face With Halo',
        codes: ['innocent'],
        snippets: [],
        default: 'innocent',
        fileName: 'yard-smiley-30',
        emoji: '\u{1F607}',
    },
];

export class EmojiService {
    convert(message: string) {
        return EMOJI_MAP.reduce((content, emoji) => {
            // apply codes (eg :rotfl:)
            let codesApplied = this.replaceCodes(
                content,
                emoji.codes.map((code) => `:${code}:`),
                emoji.emoji
            );

            // apply legacy codes, eg. "(like)"
            let legacyCodesApplied = this.replaceCodes(
                codesApplied,
                emoji.codes.map((code) => `(${code})`),
                emoji.emoji
            );

            // apply emoticons (eg. :) )
            return this.replaceCodes(legacyCodesApplied, emoji.snippets, emoji.emoji);
        }, message);
    }

    private escapeSpecialChars(regex: string) {
        return regex.replace(/([()[{*+.$^\\|?])/g, '\\$1');
    }

    private replaceCodes(textInput: string, codes: string[], emoji: string) {
        return codes.reduce((text, code) => {
            const escapedCode = this.escapeSpecialChars(code);

            // We can't replace emojis in any position, consider the following url
            // https://youtu.be/watch?key=xD7shSpff - notice the "xD" shortcode in "key" QS.
            //
            // We need to make sure we are not using codes inside other words.
            // We could use Regex lookaheads, but those do not work in Safari atm.
            const tryMatches = [
                { pattern: `^(${escapedCode})$`, replace: emoji },
                { pattern: `^(${escapedCode}) `, replace: `${emoji} ` },
                { pattern: ` (${escapedCode}) `, replace: ` ${emoji} ` },
                { pattern: ` (${escapedCode})$`, replace: ` ${emoji}` },
            ];

            return tryMatches.reduce((textValue, patternGroup) => {
                const regex = new RegExp(patternGroup.pattern, 'gim');
                return textValue.replace(regex, patternGroup.replace);
            }, text);
        }, textInput);
    }
}

angular.module('tradersyard').service('EmojiService', EmojiService);

(function () {
    // TODO: get rid of this filter soon. In few weeks no-one should care about emojis in very old messages
    angular.module('tradersyard').filter('emojis', emojisFilterFactory);

    emojisFilterFactory.$inject = ['EmojiService'];

    function emojisFilterFactory(EmojiService: EmojiService) {
        return function emojiFilter(message: string) {
            return EmojiService.convert(message);
        };
    }
})();
